export const listProvidersWordings = state => state.providersWordings.allProvidersWordings;

export const showProvidersWordings = (state, providersWordingId) => state.providersWordings.allProvidersWordings.find(t => t.id === providersWordingId);

export const getTotalCount = state => state.providersWordings.totalCount;

export const listProvidersWordingsFilters = state => state.providersWordings.filters;
